/**
 * @generated SignedSource<<4a932f6d3e62b411713cd04644938efb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SmartsFeedbackComponent_contentContributors$data = {
  readonly isCurrentUserContributor: boolean | null;
  readonly " $fragmentType": "SmartsFeedbackComponent_contentContributors";
};
export type SmartsFeedbackComponent_contentContributors$key = {
  readonly " $data"?: SmartsFeedbackComponent_contentContributors$data;
  readonly " $fragmentSpreads": FragmentRefs<"SmartsFeedbackComponent_contentContributors">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SmartsFeedbackComponent_contentContributors",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    }
  ],
  "type": "ContentContributors"
};

(node as any).hash = "7adeddd7d247d06fb9eae3b9b9dcf117";

export default node;
